module.exports = __webpack_public_path__ + "static/media/fam-pic.d6b15ed3.jpg";